<div class="w-100 d-flex flex-column align-items-center mt-2">
  <app-button-label [labelsEdit]="labels"> </app-button-label>

  <data-table
    class="w-100"
    title=""
    [columns]="columnEquipment"
    [configuration]="configurationEquipment"
    [reloadTable]="reloadTableEquipment"
    (clickRow)="clickRowEquipment($event)"
    [params]="[{id:'state', value: 1}]"
    [url]="urlTableEquipment"
  >
  </data-table>

  <button
    matStepperNext
    style="width: 70%; margin: 15px 0 15px 0"
    color="primary"
    class="button-save mat-elevation-z5"
    mat-raised-button
    (click)="validateEquipment()"
  >
    Continuar
  </button>
</div>
